<template>

  <div class="Mologin"
       id="mologin">
    <div class="Mologin_head">
      <a @click="back()">
        <i class="iconfont icon-fanhui"></i>
      </a>
    </div>
    <div class="Mologin_cont">
      <div class="cont_tit">
        <p>手机号登录</p>
        <i class="line"></i>
      </div>
      <el-form size="small"
               :model="form"
               :rules="formRules"
               ref="loginForm"
               class="main_form">
        <div class="logCont_div">
          <i class="iconfont icon-shouji"></i>
          <el-form-item prop="loCell">
            <el-input placeholder="请输入手机号"
                      v-model="form.loCell"></el-input>
          </el-form-item>
        </div>
        <div class="logCont_div">
          <i class="iconfont icon-mima"></i>
          <el-form-item prop="loPassword">
            <el-input placeholder="请输入密码"
                      type="password"
                      v-model="form.loPassword"
                      @keyup.enter.native="LoginUser"></el-input>
          </el-form-item>
        </div>
        <div class="logCont_div verCode">
          <el-input placeholder="请输入图形验证码"
                    v-model="form.loVerCode"
                    @keyup.enter.native="LoginUser"></el-input>
          <div class="sendCodeB"
               @click="refreshCode">
            <Sidentify :identifyCode="identifyCode"
                       style="position: relative;top: 3px;left: 17px;cursor: so;cursor: pointer;"></Sidentify>
          </div>
        </div>
        <div class="logCont_div logibtn"
             @click="LoginUser()">
          登录
        </div>
        <router-link :to="{name:'moregister',query:{callback:decodeURIComponent(this.callbackurl)}}">
          <p class="alerdybtn fl">注册新用户</p>
        </router-link>
        <router-link :to="{name:'mofindpsdOne',query:{callback:decodeURIComponent(this.callbackurl)}}">
          <p class="alerdybtn fr">找回密码</p>
        </router-link>
      </el-form>
    </div>
  </div>
</template>
<script>
import Sidentify from '../identify'
import validate from '../../assets/unit/validate';
export default {
  data () {
    const VALIDATE_MOBILE_NO = (rule, value, callback) => {
      if (!validate.validateMobile(value)) {
        callback(new Error("手机号需为11位数字"));
      } else {
        callback();
      }
    };
    return {
      // 数字验证码
      identifyCodes: "1234567890",
      identifyCode: "",
      form: {
        loCell: '',
        loPassword: '',
        loVerCode: '',
        lochecked: true,
      },
      callbackurl: '',
      formRules: {
        loCell: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: VALIDATE_MOBILE_NO, trigger: 'blur' }
        ],
        loPassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
      },
      redirectUrl: '',
      userType: ''
    }
  },
  methods: {
    // 登录
    LoginUser () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          if (this.form.loVerCode != this.identifyCode) {
            this.$msgmodal({
              title: '系统提示',
              content: '验证码错误!',
              type: 'warn',
            });
            this.form.loVerCode = ''
            this.refreshCode()
          } else {
            this.httphelper.post('/api/LoginApi/GetUserLogin',
              {
                phoneNumber: this.form.loCell,
                pwd: this.form.loPassword
              }).then((res) => {
                if (res.data.code == 232) {
                  this.$msgmodal({
                    title: '系统提示',
                    content: '账号不存在!',
                    type: 'warn',
                  });
                } else if (res.data.code == 205) {
                  this.$msgmodal({
                    title: '系统提示',
                    content: '密码错误!',
                    type: 'warn',
                  });
                  this.form.loVerCode = ''
                  this.refreshCode()
                } else if (res.data.code == 260) {
                  this.$msgmodal({
                    title: '系统提示',
                    content: '账号未激活!',
                    type: 'warn',
                  });
                  this.LoginFormInfo = false
                  this.LoginBtnSend = true
                } else if (res.data.code == 200) {
                  this.ResData = JSON.stringify(res.data.data)
                  localStorage.setItem('ResData', this.ResData)
                  localStorage.setItem('nickname', res.data.data.nickname)
                  var aData = new Date();
                  var CurrentDategetTime = 0
                  var VipEdDategetTime = 0
                  if (res.data.data.memberDate.m_EndDate) {
                    var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
                    var VipEdDate = res.data.data.memberDate.m_EndDate;

                    CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
                    VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
                  }
                  if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                    this.userType = 0;
                  } else {
                    if (res.data.data.memberDate.m_Type == 1) {
                      this.userType = 1;
                    } else if (res.data.data.memberDate.m_Type == 2) {
                      this.userType = 2;
                    } else {
                      this.userType = 0;
                    }
                  }
                  localStorage.setItem('userType', this.userType);
                  //跳转页面
                  this.$cookies.set('token_chinagp', res.data.data.token);
                  let redirectUrl = '';
                  if (this.callbackurl != '') {
                    redirectUrl = decodeURIComponent(this.callbackurl);
                    window.location.href = redirectUrl
                  }
                }
              })
          }
        }
      })
    },
    // 数字验证码
    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode () {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    back () {
      if (this.callbackurl != '') {
        let redirectUrl = decodeURIComponent(this.callbackurl);
        window.location.href = redirectUrl;
      }
    }
  },
  components: {
    Sidentify,
  },
  created () {
    /** 获取callback地址 */
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'callback')) {
      this.callbackurl = encodeURIComponent(this.$route.query.callback);
    }
    if (this.$route.query.findpswCell) {
      this.form.loCell = this.$route.query.findpswCell
    }
  },
  mounted () {
    this.refreshCode()
  }

}
  </script>
<style   scoped>
.Mologin_head {
    padding-left: 10px;
    text-align: center;
    position: fixed;
    top: 0;
    width: 100%;
    left: 0;
    background: #fff;
    height: 40px;
    z-index: 99;
    line-height: 60px;
}
.Mologin_head >>> a {
    position: absolute;
    left: 30px;
}
.Mologin_cont {
    width: 100%;
    position: relative;
    top: 38px;
}
.cont_tit {
    width: 90px;
    margin-left: 30px;
    margin-top: 50px;
}
.cont_tit >>> p {
    color: #157eff;
    font-size: 18px;
}
.line {
    width: 30px;
    height: 4px;
    background: #0082fe;
    border-radius: 2px;
    display: inherit;
    margin: 0 auto;
    margin-top: 10px;
}
.main_form {
    width: 80%;
    height: auto;
    margin: 0 auto;
    margin-top: 45px;
}
.logCont_div {
    width: 100%;
    height: 42px;
    border-bottom: 1px solid #ebebeb;
    margin-bottom: 27px;
    line-height: 42px;
    position: relative;
}
.logCont_div >>> i {
    color: #878787;
    font-size: 21px;
    margin-left: 17px;
}
.logCont_div >>> .el-form-item {
    position: absolute;
    top: 0;
    width: 84%;
    height: 100%;
    margin-left: 40px;
}
.logCont_div >>> .el-input__inner {
    border: none;
    height: 42px;
    line-height: 42px;
    color: #878787;
    font-size: 15px;
}
.verCode {
    width: 100%;
    border: none;
}
.verCode >>> .el-input {
    width: 60%;
    float: left;
    border-bottom: 1px solid #ebebeb;
}

.verCode >>> .sendCodeB {
    width: 34%;
    height: 40px;
    float: left;
    color: #fff;
    font-size: 22px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    letter-spacing: 8px;
}
.logibtn {
    width: 100%;
    margin: 0 auto;
    height: 34px;
    background: #157eff;
    box-shadow: 0px 1px 10px 0px rgba(21, 126, 255, 0.5);
    border-radius: 17px;
    margin-top: 49px;
    text-align: center;
    line-height: 34px;
    color: #ffffff;
    font-size: 16px;
}

.wxlogin {
    width: 80%;
    margin: 0 auto;
    margin-top: 80px;
    text-align: center;
}
/* .wxormethod {
        div {
            display: inline-block;
        }
        div:nth-child(1),
        div:nth-child(3) {
            width: 25px;
            height: 1px;
            background: #ebebeb;
        }
        div:nth-child(2) {
            color: #878787;
            font-size: 15px;
            margin-left: 5px;
            margin-right: 5px;
            position: relative;
            top: 4px;
        }
    } */
.wxlogimg {
    width: 34px;
    height: 34px;
    margin: 0 auto;
    margin-top: 26px;
}

.main_form >>> .alerdybtn {
    text-align: center;
    color: #157eff;
    font-size: 15px;
    margin-top: 19px;
}

.main_form >>> .alerdybtn >>> a {
    color: #157eff;
}

.fl {
    float: left;
}

.fr {
    float: right;
}
</style>
 
   